import { useCallback, useState } from 'react';
import { Segmented, Typography, theme } from 'antd';
import { SettingOutlined, UserOutlined } from '@ant-design/icons';
import useIsAdmin from '../../hooks/use_is_admin';
import MemberView from '../Gathering/MemberView';
import AdminView from '../Gathering/AdminView';
import { PALETTE_KEYS } from '../Gathering/GatheringPage';
import '../Gathering/Gathering.css';

const { Paragraph } = Typography;

// The gathering app (backend sdk_apps/gathering.py) on the app page: the
// node's gathering screens (components/Gathering/) run on this instance's
// views and verbs instead of /api/gathering. Everyone who can use the app
// gets the member view; whoever administers it (installed it, administers a
// host, a superadmin) can switch to the admin view and run it. Following
// the flow live is /app/:id/flow, the same page as /gathering/flow.
function GatheringApp({ instance }) {
    const { token } = theme.useToken();
    const { isAdmin } = useIsAdmin(instance.id);
    const [view, setView] = useState('member');
    const showAdmin = isAdmin && view === 'admin';
    const paletteColor = useCallback(i => token[PALETTE_KEYS[(i ?? 0) % PALETTE_KEYS.length]], [token]);

    return (
        <div className="gathering-page gathering-page--app">
            {isAdmin && (
                <div className="gathering-header">
                    <Segmented
                        value={showAdmin ? 'admin' : 'member'}
                        onChange={setView}
                        options={[
                            { label: 'Member view', value: 'member', icon: <UserOutlined /> },
                            { label: 'Admin view', value: 'admin', icon: <SettingOutlined /> },
                        ]}
                    />
                </div>
            )}
            {showAdmin && (
                <Paragraph type="secondary" className="gathering-lede">
                    People of the entities this gathering is installed in mark themselves into groups. Describe the ideal room,
                    check the plan, adjust it by hand, then publish so everyone sees their room.
                </Paragraph>
            )}
            {showAdmin
                ? <AdminView paletteColor={paletteColor} instanceId={instance.id} />
                : <MemberView colorOf={g => paletteColor(g.color)} instanceId={instance.id} />}
        </div>
    );
}

export default GatheringApp;
